import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const onClick = () => map.commands.exportReq('1')

    return {
        key: 'export-biz-req',
        label: '导出业务需求文档',
        onClick,
    }
}
